import React, { useEffect, useState } from "react";
import useForm from "../../hooks/useForm";
import Input from "../form/Input";
import { formValidate } from "../../helpers/formValidate";
import PhoneNumberFormat from "../form/PhoneNumberFormat";
import Button from "../form/Button";
import Tooltip from "../elements/Tooltip";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { profileUpdate } from "../../services/ProfileService";
import Form from "../form/Form";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { setProfile } from "../../redux/slice/profileSlice";
import DatePicker from "../form/DatePicker";

function ProfileComponent({ image, setImage = () => {} }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.profile?.data);
  const [phone, setPhone] = useState("");

  const validation = {
    firstName: { required: true, message: "Please enter your first name!" },
    lastName: { required: true, message: "Please enter your last name!" },
  };
  const { values, handleChange, handleSubmit, errors, setFieldsValue } =
    useForm({ validationRules: validation });

  useEffect(() => {
    if (user) {
      setFieldsValue({
        firstName: user?.firstName || "",
        lastName: user?.lastName || "",
        email: user?.email || "",
        dob: user?.dob || "",
        address: user?.address[0]?.address1|| "",
      });
      setPhone(user?.phone || "");
      setImage(user?.image?.url || "");
    }
  }, [user]);

  useEffect(()=>{
    console.log(values)
  },[values])

  const {
    mutate: onSubmit,
    error: signUpError,
    isPending: profileLoding,
  } = useMutation({
    mutationFn: async (val) => {
      return await profileUpdate({
        firstName: val?.firstName,
        lastName: val?.lastName,
        // phone: phone || "",
        image: image || "null",
        "address[address1]": values.address,
        dob: values.dob,
      });
    },
    onSuccess: async (res) => {
      if (res?.status === 200 || res?.status === 201) {
        toast.success(res?.message || res?.data?.message);
        dispatch(setProfile({ ...user, loading: false, ...(res?.data || {}) }));
      } else {
        toast?.error(
          res?.data?.message || res?.error || "Something went wrong"
        );
      }
    },
  });

  return (
    <div className="grid grid-cols-12 gap-6 py-6 xls:pr-10">
      {/* Profile Info Form Section */}
      <div className="col-span-12 flex flex-col space-y-6">
        <Form
          onSubmit={onSubmit}
          handleSubmit={handleSubmit}
          loading={profileLoding}
        >
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <Input
                label={"First Name"}
                inputType={"text"}
                value={values?.firstName}
                inputPlaceholder={"Enter first name"}
                inputName="firstName"
                onChange={handleChange}
                isValidate={true}
                required={true}
                charLimit={20}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "firstName")}
              />
            </div>

            <div>
              <Input
                label={"Last Name"}
                inputType={"text"}
                value={values?.lastName}
                inputPlaceholder={"Enter last name"}
                inputName="lastName"
                required={true}
                onChange={handleChange}
                isValidate={true}
                charLimit={20}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "lastName")}
              />
            </div>

            <div>
              <Input
                label={"Email"}
                inputType={"email"}
                value={values?.email}
                inputPlaceholder={"Enter email"}
                inputName="email"
                onChange={handleChange}
                isValidate={true}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "email")}
                isDisabled={true}
                required={true}
              />
            </div>

            <div>
              <DatePicker
                label={"Select DOB"}
                labelClasses={"!text-slate-600"}
                position="fixed"
                onChange={(e) =>
                  handleChange({
                    target: {
                      name: "dob",
                      value: e?.startDate || e?.endDate,
                    },
                  })
                }
                value={{
                  startDate: values?.dob,
                  endDate: values?.dob,
                }}
                {...formValidate(errors, "dob")}
              />
            </div>

            {/* <div>
              <PhoneNumberFormat
                label="Phone"
                value={phone}
                isInputGroup={true}
                inputGroupIcon={"fa-solid fa-phone"}
                inputGroupPosition={"left"}
                setPhone={setPhone}
                inputPlaceholder={"(XXX) XXXX-XXXX"}
                charLimit={12}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                required={true}
              />
            </div> */}
            <div>
              <Input
                label={"Address"}
                inputType={"text"}
                value={values?.address}
                inputPlaceholder={"Enter your address"}
                inputName="address"
                onChange={handleChange}
                isValidate={true}
                charLimit={20}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "address")}
              />
            </div>
            
            {/* <div>
              <Input
                label={"Address 2"}
                inputType={"text"}
                value={values?.address?.address2}
                inputPlaceholder={"Enter your address2"}
                inputName="address2"
                onChange={handleChange}
                isValidate={true}
                charLimit={20}
                inputClasses={"!h-11 md:!h-11"}
                labelClasses={"!text-xs !text-slate-600"}
                {...formValidate(errors, "address")}
              />
            </div> */}
          </div>

          <div className="flex justify-end items-baseline">
            <Button
              buttonType={"submit"}
              buttonIcon={"fa-light fa-floppy-disk"}
              buttonIconPosition={"left"}
              buttonLabel="Save"
              loading={profileLoding}
              isDisable={profileLoding}
              buttonLabelClasses={"!text-sm"}
              buttonClasses="!py-2 !px-2 rounded-lg text-white !h-auto !bg-primary hover:!bg-red-600"
            />
            <Tooltip
              id="edit-profile"
              className="!text-slate-500 !text-sm !bg-slate-950 !bg-opacity-100 z-100"
              render={() => (
                <div className="text-white">Click to save profile details.</div>
              )}
            />
          </div>
        </Form>
      </div>
    </div>
  );
}

export default ProfileComponent;
